import React, { useEffect, useState, useRef } from "react";
import { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ComponentToPrint } from "./ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import { removeEUPrivateShieldProvatePolicyLink } from "../../util/common";

const EuUsGDPRPolicy = () => {
    const [state, setState] = useState({ isLoading: true, content: "" });
    const dispatch = useDispatch();
    const componentRef: any = useRef();
    const handlePrint: any = useReactToPrint({
        content: () => componentRef.current,
    } as any);
    const contents: string = state.content;
    const footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const userInfo = useSelector((state: ApplicationState) => {
        if (state.configurationState?.configuration?.partnerConfig != null) {
            return {
                partnerId: state.configurationState.configuration.partnerConfig.partnerId,
            };
        }
        return { partnerId: 36 };
    });
    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a href="javascript:window.print()">
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1 || attribs.href.indexOf("terms-of-use") !== -1)
                    return (
                        <a href="/terms" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("privacy-policy") !== -1 ||
                    attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                    attribs.href.indexOf("PrivacyPolicy") !== -1
                )
                    return (
                        <a href="/privacy" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                    attribs.href.indexOf("privacy-shield-policy") !== -1
                )
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return (
                        <a href="/ccpa" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    );
            }
        },
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                PartnrID: data.PartnerID,
                ModuleCustomSettingsId: data.ModuleCustomSettingsId,
            },
            body: JSON.stringify(data),
        });
    };

    useEffect(() => {
        const url = "api/GetPartnerCustomHtml/GetPartnerCustomHtml";
        const data: any = {
            PartnerID: 536,
            ModuleCustomSettingsId: 12342,
        };
        callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                if (res["hasError"] === false && res["legalDocuments"].length) {
                    setState({
                        isLoading: false,
                        content: removeEUPrivateShieldProvatePolicyLink(res["legalDocuments"][0].value),
                    });
                }
            })
            .catch((error: Error): any => console.log(error));
    }, [setState]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="faux-main-container">
                <div className=" row">
                    <div className="col-xs-12"></div>
                </div>

                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box box-has-shadow">
                            {state.isLoading ? (
                                <div className="box-content loading"></div>
                            ) : (
                                <ComponentToPrint ref={componentRef} content={contents} authData={authData} title={"EU-US GDPR Policy"} handlePrint={handlePrint} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: footerLogoHTML }}></div>
            </div>
        </React.Fragment>
    );
};

export default EuUsGDPRPolicy;
